import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, Trophy, ShieldCheck, Flame, TrendingUp } from 'lucide-react';

interface SocialImpactBannerProps {
  companyName?: string;
}

export const SocialImpactBanner: React.FC<SocialImpactBannerProps> = ({ companyName = 'Akretrix Enterprise Cohort' }) => {
  const { t } = useLanguage();

  return (
    <div
      className="glass-card"
      style={{
        padding: '16px 20px',
        borderRadius: 'var(--radius-lg)',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, rgba(30, 58, 138, 0.25) 0%, rgba(15, 23, 42, 0.6) 100%)',
        border: '1px solid rgba(59, 130, 246, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '12px',
            background: 'rgba(59, 130, 246, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#60a5fa',
            flexShrink: 0,
          }}
        >
          <Users size={22} />
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '11px', fontWeight: 800, color: '#60a5fa', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
              {t('Prueba Social & Impacto Colectivo (Pertenencia)', 'Social Proof & Collective Impact (Relatedness)')}
            </span>
            <span style={{ fontSize: '11px', background: 'rgba(16, 185, 129, 0.15)', color: '#34d399', padding: '1px 6px', borderRadius: '4px', fontWeight: 700 }}>
              Top 5% Cohort
            </span>
          </div>
          <div style={{ fontSize: '13.5px', fontWeight: 600, color: 'var(--text-primary)', marginTop: '2px' }}>
            {t(
              `Tu equipo en ${companyName} ha mitigado 1,420 riesgos legales en simulaciones este mes.`,
              `Your team at ${companyName} collectively mitigated 1,420 legal risks in simulations this month.`
            )}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '18px', alignItems: 'center' }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)', textTransform: 'uppercase', fontWeight: 700 }}>
            {t('Hall of Fame', 'Hall of Fame')}
          </div>
          <div style={{ fontSize: '13px', fontWeight: 800, color: '#f59e0b', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Trophy size={14} /> #1 {t('en Integridad Ética', 'in Ethical Integrity')}
          </div>
        </div>
      </div>
    </div>
  );
};
